<template>
  <div
    class="presidential-elections-first-round"
    :class="{ container: !isElectionTag }"
    v-if="presidentialElectionsFirstRoundData"
  >
    <template v-if="isElectionTag">
      <div class="wrap-select">
        <select
          class="states-select"
          name="states"
          id="states"
          placeholder="Seleccione un departamento"
          v-model="selectedState"
          @change="getState(selectedState)"
        >
          <option
            v-for="state in presidentialElectionsFirstRoundData.states"
            :key="state"
            :value="state"
          >
            {{ state }}
          </option>
        </select>
        <div class="select-icon">
          <i class="icon-arrow-left"></i>
        </div>
      </div>
      <div class="wrap-bulletin">
        <div class="bulletin">
          AVANCE
          <span
            class="number-bulletin"
            v-html="
              presidentialElectionsFirstRoundData.bulletin
                .nationalBulletinNumber
            "
          ></span>
        </div>
        <span v-html="currentTime" class="current-time"></span>
      </div>
    </template>
    <template v-else>
      <div class="general-elections">
        <h3 class="heading-title">
          Elecciones Presidenciales 2026 - Primera Vuelta
        </h3>
        <div class="wrap-bulletin">
          <div class="bulletin">
            AVANCE
            <span
              class="number-bulletin"
              v-html="
                presidentialElectionsFirstRoundData.bulletin
                  .nationalBulletinNumber
              "
            ></span>
          </div>

          <span v-html="currentTime" class="current-time"></span>
        </div>
      </div>
    </template>
    <div class="first-col">
      <template
        v-for="item in presidentialElectionsFirstRoundData.candidates.slice(
          0,
          2,
        )"
      >
        <div class="card-election-1">
          <img
            :alt="item.name"
            :title="item.name"
            :src="`${item.image}?w=320`"
            :height="210"
            :width="210"
          />
          <div class="info-candidate">
            <div class="candidate-name" v-html="item.name"></div>
            <div class="votes">Votos {{ format(item.votes) }}</div>
            <div class="bar">
              <div
                class="r"
                :style="{
                  width: item.percentage * 100 + '%',
                }"
              ></div>
            </div>
            <div
              class="percentage"
              v-html="formatPercent(item.percentage)"
            ></div>
          </div>
        </div>
      </template>
    </div>
    <div class="wrap-second-col">
      <div class="second-col">
        <template
          v-for="item in presidentialElectionsFirstRoundData.candidates.slice(
            2,
            isElectionTag ? 14 : 8,
          )"
        >
          <div class="card-election-2">
            <div class="candidate-name" v-html="item.name"></div>
            <div class="info-candidate">
              <div class="poll-results">
                <div class="votes">
                  <strong>Votos</strong> {{ format(item.votes) }}
                </div>
                <div class="bar">
                  <div
                    class="r"
                    :style="{
                      width: item.percentage * 100 + '%',
                    }"
                  ></div>
                </div>
              </div>
              <hr class="v" />
              <div
                class="percentage"
                v-html="formatPercent(item.percentage)"
              ></div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="third-col">
      <div class="card-info c-1">
        <div class="row-1">
          <div class="percentage">
            {{
              formatPercent(
                presidentialElectionsFirstRoundData.bulletin
                  .percentageInformedTables,
              )
            }}
          </div>
          <div class="informed-tables">Mesas Informadas</div>
        </div>
        <div class="row-2">
          {{
            format(presidentialElectionsFirstRoundData.bulletin.informedTables)
          }}
          de
          {{ format(presidentialElectionsFirstRoundData.bulletin.totalTables) }}
          mesas informadas
        </div>
      </div>
      <div class="card-info c-2">
        <div class="row-1">
          <div class="percentage">
            {{
              formatPercent(
                presidentialElectionsFirstRoundData.bulletin
                  .percentageTotalVotes,
              )
            }}
          </div>
          <div class="vote">Votación</div>
        </div>
        <div class="row-2">
          {{ format(presidentialElectionsFirstRoundData.bulletin.totalVotes) }}
          de
          {{
            format(presidentialElectionsFirstRoundData.bulletin.potentialVotes)
          }}
          personas habilitadas
        </div>
      </div>
      <div class="card-info">
        <div class="row-1">
          <div class="percentage">
            {{
              formatPercent(
                presidentialElectionsFirstRoundData.bulletin
                  .percentageBlankVotes,
              )
            }}
          </div>
          <div class="vote">En Blanco</div>
        </div>
        <div class="row-2">
          {{ format(presidentialElectionsFirstRoundData.bulletin.blankVotes) }}
          votos
        </div>
      </div>
      <div class="card-info">
        <div class="row-1">
          <div class="percentage">
            {{
              formatPercent(
                presidentialElectionsFirstRoundData.bulletin
                  .percentageNullVotes,
              )
            }}
          </div>
          <div class="vote">Nulos</div>
        </div>
        <div class="row-2">
          {{ format(presidentialElectionsFirstRoundData.bulletin.nullVotes) }}
          votos
        </div>
      </div>
    </div>
    <div class="button" v-if="presidentialElectionsUrl && !isElectionTag">
      <a :href="presidentialElectionsUrl" class="btn">RESULTADOS COMPLETOS</a>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import "dayjs/locale/es";
import { useLRWebSocketV2 } from "../../../features/lr-websocket-v2.js";

export default {
  props: {
    presidentialElectionsUrl: {
      type: String,
      required: false,
    },
    isElectionTag: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  data() {
    return {
      selectedState: "Nacional",
    };
  },

  created() {
    this.$store.dispatch("elections/getPres2026_1_Home");
    useLRWebSocketV2(this.$store);
  },
  computed: {
    presidentialElectionsFirstRoundData() {
      return this.$store.getters["elections/pres2026_1_home"];
    },

    currentTime() {
      if (!this.presidentialElectionsFirstRoundData) return "";

      return dayjs(this.presidentialElectionsFirstRoundData.bulletin.date)
        .locale("es")
        .format("hh:mm a");
    },
  },

  methods: {
    formatPercent(value) {
      if (value === null || value === undefined) return "";

      return value.toLocaleString("es-CO", {
        style: "percent",
        maximumFractionDigits: 2,
      });
    },
    format(value) {
      if (value === null || value === undefined) return "";

      return value.toLocaleString("es-CO");
    },
    getState(state) {
      this.$store.dispatch("elections/getPres2026_1_Home", state);
    },
  },
};
</script>
